import React from 'react';

import { FormField } from 'components';

const ComplementaryItemFields = () => (
  <>
    <FormField
      name="complementaryItem"
      label="Complementary Item (Optional)"
      tooltip="If this item pairs well with another, mention it here. Helps AI generate bundle promotions."
    />
    <FormField
      name="complementaryItemDescription"
      label="Complementary Item Description (Optional)"
      tooltip="Briefly describe how the items complement each other."
      type="textarea"
    />
  </>
);

export default ComplementaryItemFields;
